import { DateFormatter } from "@/utils/date";

const saldoDate = new Date();
const currentDate = new Date();
// saldoDate.setDate(0); //last day of previous month
saldoDate.setDate(saldoDate.getDate() - 1);

var monthNames = {};
for (var i = 0; i < DateFormatter.monthNames.length; ++i) {
    var s = "0" + (i + 1); //Index starts at 0 but Months start at 1
    monthNames[s.substr(s.length - 2)] = DateFormatter.monthNames[i]; //remove everything thats longer than 2 chars
}

const getDefaultState = () => {
    return {
        Andere: {
            allgemein: {
                Name: "Produktname",
                ContractIdFormatted: "Vertragsnummer",
                Balance: {
                    label: "Kontostand",
                    type: "currency",
                },
                // FromDate: {
                //     label: "Vertragsbeginn",
                //     type: "date"
                // },
                ToDate: {
                    label: "Vertragsende",
                    type: "date",
                },
                State: "Status des Produkts",
            },
            zahlung: {
                AccountHolderName: "Inhaber",
                BankName: "Bank",
                Iban: {
                    label: "IBAN",
                    type: "iban",
                },
                Bic: "BIC",
                DirectDebitDay: {
                    label: "Abbuchungszeitpunkt",
                    type: "replace",
                    replace: {
                        5: "Am 5. des Monats",
                        15: "Am 15. des Monats",
                        25: "Am 25. des Monats",
                    },
                },
                // geschlecht: {
                //     type: "replace",
                //     label: "Geschlecht",
                //     replace: {
                //         Herr: "männlich",
                //         Frau: "weiblich"
                //     }
                // },
                // titel: "Titel",
                vorname: "Vorname",
                nachname: "Nachname",
                // telefon: "Telefon",
                // email: "E-Mail",
                geburtstag: "Geburtsdatum",
                // strasse: "Straße",
                // hausnummer: "Hausnummer",
                // plz: "PLZ",
                // ort: "Ort"
            },
            person: {
                mainHeadline: "Vertragsinhaber",
                secondHeadline: "Gesetzlicher Vertreter",
                // geschlecht: {
                //     type: "replace",
                //     label: "Geschlecht",
                //     replace: {
                //         Herr: "männlich",
                //         Frau: "weiblich"
                //     }
                // },
                // titel: "Titel",
                vorname: "Vorname",
                nachname: "Nachname",
                // telefon: "Telefon",
                // email: "E-Mail",
                geburtstag: "Geburtsdatum",
                // strasse: "Straße",
                // hausnummer: "Hausnummer",
                // plz: "PLZ",
                // ort: "Ort"
            },
            produkt: {
                PaymentMode: {
                    label: "Zahlungsart",
                    type: "replace",
                    replace: {
                        OTHER: "individuelle Zahlungsweise",
                        DIRECTDEBIT: "SEPA-Lastschrift",
                        CREDITTRANSFER: "Überweisung",
                        PAYMENTFORM: "Zahlschein",
                        POSTALPAYMENT: "individuelle Zahlungsweise",
                    },
                },
                PaymentInterval: {
                    label: "Abbuchungszyklus",
                    type: "replace",
                    replace: {
                        MONTHLY: "monatlich",
                        YEARLY: "jährlich",
                        "HALF-YEARLY": "halbjährlich",
                        SINGULAR: "einmalig",
                        QUARTERLY: "vierteljährlich",
                        "BI-MONTHLY": "zweimonatlich",
                        IRREGULAR: "optional",
                        //monatlich/vierteljährlich/jährlich/einmalig
                    },
                },
                GrossAmount: {
                    label: "Abbuchungsbetrag",
                    type: "currency",
                },
            },
        },
        Ansparen: {
            allgemein: {
                Name: "Produktname",
                ContractIdFormatted: "Vertragsnummer",
                Balance: {
                    label:
                        "Kontostand per " +
                        DateFormatter.formatDate(currentDate, "DD.MM.YYYY") +
                        "<br>ohne Zinsen für das laufende Jahr",
                    type: "currency",
                },
                // FromDate: {
                //     label: "Vertragsbeginn",
                //     type: "date"
                // },
                State: "Status des Produkts",
            },
            zahlung: {
                AccountHolderName: "Inhaber",
                BankName: "Bank",
                Iban: {
                    label: "IBAN",
                    type: "iban",
                },
                Bic: "BIC",
                DirectDebitDay: {
                    label: "Abbuchungszeitpunkt",
                    type: "replace",
                    replace: {
                        5: "Am 5. des Monats",
                        15: "Am 15. des Monats",
                        25: "Am 25. des Monats",
                    },
                },
                // geschlecht: {
                //     type: "replace",
                //     label: "Geschlecht",
                //     replace: {
                //         Herr: "männlich",
                //         Frau: "weiblich"
                //     }
                // },
                // titel: "Titel",
                vorname: "Vorname",
                nachname: "Nachname",
                // telefon: "Telefon",
                // email: "E-Mail",
                geburtstag: "Geburtsdatum",
                // strasse: "Straße",
                // hausnummer: "Hausnummer",
                // plz: "PLZ",
                // ort: "Ort",

                PaymentMode: {
                    label: "Zahlungsart",
                    type: "replace",
                    replace: {
                        OTHER: "individuelle Zahlungsweise",
                        DIRECTDEBIT: "SEPA-Lastschrift",
                        CREDITTRANSFER: "Überweisung",
                        PAYMENTFORM: "Zahlschein",
                        POSTALPAYMENT: "individuelle Zahlungsweise",
                    },
                },
                PaymentInterval: {
                    label: "Abbuchungszyklus",
                    type: "replace",
                    replace: {
                        MONTHLY: "monatlich",
                        YEARLY: "jährlich",
                        "HALF-YEARLY": "halbjährlich",
                        SINGULAR: "einmalig",
                        QUARTERLY: "vierteljährlich",
                        "BI-MONTHLY": "zweimonatlich",
                        IRREGULAR: "optional",
                        //monatlich/vierteljährlich/jährlich/einmalig
                    },
                },
                GrossAmount: {
                    label: "Abbuchungsbetrag",
                    type: "currency",
                },
                FromDate: {
                    label: "Erstmals ab",
                    type: "date",
                },
            },
            person: {
                mainHeadline: "Vertragsinhaber",
                secondHeadline: "Versicherte Person",
                thirdHeadline: "Versichertes Kind",
                // geschlecht: {
                //     type: "replace",
                //     label: "Geschlecht",
                //     replace: {
                //         Herr: "männlich",
                //         Frau: "weiblich"
                //     }
                // },
                // titel: "Titel",
                vorname: "Vorname",
                nachname: "Nachname",
                // telefon: "Telefon",
                // email: "E-Mail",
                geburtstag: "Geburtsdatum",
                // strasse: "Straße",
                // hausnummer: "Hausnummer",
                // plz: "PLZ",
                // ort: "Ort"
            },
            produkt: {
                AktuelleSparrate: {
                    label: "aktuelle Sparrate",
                    type: "currency",
                },
                Wertanpassung: {
                    label: "Wertanpassung",
                    type: "replace",
                    replace: {
                        J: "ja",
                        N: "nein",
                    },
                },
                Duration: "Laufzeit (Jahre)",
                FromDate: {
                    label: "Vertragsbeginn",
                    type: "date",
                },
                ToDate: {
                    label: "Vertragsende",
                    type: "date",
                },
            },
        },
        LebenRisiko: {
            allgemein: {
                Name: "Produktname",
                ContractIdFormatted: "Polizzennummer",
                // ContractAmount: {
                //     label: "Versicherungssumme",
                //     type: "currency"
                // },
                // FromDate: {
                //     label: "Vertragsbeginn",
                //     type: "date"
                // },
                // ToDate: {
                //     label: "Vertragsende",
                //     type: "date"
                // },
                State: "Status des Produkts",
                // GrossAmount: {
                //     label: "aktuelle Prämie",
                //     type: "currency"
                // }
            },
            zahlung: {
                AccountHolderName: "Inhaber",
                BankName: "Bank",
                Iban: {
                    label: "IBAN",
                    type: "iban",
                },
                Bic: "BIC",
                DirectDebitDay: {
                    label: "Abbuchungszeitpunkt",
                    type: "replace",
                    replace: {
                        5: "Am 5. des Monats",
                        15: "Am 15. des Monats",
                        25: "Am 25. des Monats",
                    },
                },
                // geschlecht: {
                //     type: "replace",
                //     label: "Geschlecht",
                //     replace: {
                //         Herr: "männlich",
                //         Frau: "weiblich"
                //     }
                // },
                // titel: "Titel",
                vorname: "Vorname",
                nachname: "Nachname",
                // telefon: "Telefon",
                // email: "E-Mail",
                geburtstag: "Geburtsdatum",
                // strasse: "Straße",
                // hausnummer: "Hausnummer",
                // plz: "PLZ",
                // ort: "Ort",

                PaymentMode: {
                    label: "Zahlungsart",
                    type: "replace",
                    replace: {
                        OTHER: "individuelle Zahlungsweise",
                        DIRECTDEBIT: "SEPA-Lastschrift",
                        CREDITTRANSFER: "Überweisung",
                        PAYMENTFORM: "Zahlschein",
                        POSTALPAYMENT: "individuelle Zahlungsweise",
                    },
                },
                PaymentInterval: {
                    label: "Abbuchungszyklus",
                    type: "replace",
                    replace: {
                        MONTHLY: "monatlich",
                        YEARLY: "jährlich",
                        "HALF-YEARLY": "halbjährlich",
                        SINGULAR: "einmalig",
                        QUARTERLY: "vierteljährlich",
                        "BI-MONTHLY": "zweimonatlich",
                        IRREGULAR: "optional",
                        //monatlich/vierteljährlich/jährlich/einmalig
                    },
                },
                GrossAmount: {
                    label: "Abbuchungsbetrag",
                    type: "currency",
                },
                FromDate: {
                    label: "Erstmals ab",
                    type: "date",
                },
            },
            person: {
                mainHeadline: "Vertragsinhaber",
                secondHeadline: "Versicherte Person",
                thirdHeadline: "Versichertes Kind",
                // geschlecht: {
                //     type: "replace",
                //     label: "Geschlecht",
                //     replace: {
                //         Herr: "männlich",
                //         Frau: "weiblich"
                //     }
                // },
                // titel: "Titel",
                vorname: "Vorname",
                nachname: "Nachname",
                // telefon: "Telefon",
                // email: "E-Mail",
                geburtstag: "Geburtsdatum",
                // strasse: "Straße",
                // hausnummer: "Hausnummer",
                // plz: "PLZ",
                // ort: "Ort"
            },
            produkt: {
                GrossAmount: {
                    label: "aktuelle Prämie",
                    type: "currency",
                },
                Wertanpassung: {
                    label: "Wertanpassung",
                    type: "replace",
                    replace: {
                        J: "ja",
                        N: "nein",
                    },
                },
                Duration: "Laufzeit (Jahre)",
                FromDate: {
                    label: "Vertragsbeginn",
                    type: "date",
                },
                ToDate: {
                    label: "Vertragsende",
                    type: "date",
                },
            },
        },
        KFZ: {
            allgemein: {
                Name: "Produktname",
                ContractIdFormatted: "Polizzennummer",
                // FromDate: {
                //     label: "Vertragsbeginn",
                //     type: "date"
                // },
                // GrossAmount: {
                //     label: "aktuelle Prämie",
                //     type: "currency"
                // }
                KfzBezeichnung: "KFZ-Bezeichnung",
                // KfzBaujahr: "KFZ-Baujahr",
                // KfzLeistung: "KFZ-Leistung",
                KfzKennzeichen: "KFZ-Kennzeichen",
            },
            zahlung: {
                AccountHolderName: "Inhaber",
                BankName: "Bank",
                Iban: {
                    label: "IBAN",
                    type: "iban",
                },
                Bic: "BIC",
                DirectDebitDay: {
                    label: "Abbuchungszeitpunkt",
                    type: "replace",
                    replace: {
                        5: "Am 5. des Monats",
                        15: "Am 15. des Monats",
                        25: "Am 25. des Monats",
                    },
                },
                // geschlecht: {
                //     type: "replace",
                //     label: "Geschlecht",
                //     replace: {
                //         Herr: "männlich",
                //         Frau: "weiblich"
                //     }
                // },
                // titel: "Titel",
                vorname: "Vorname",
                nachname: "Nachname",
                // telefon: "Telefon",
                // email: "E-Mail",
                geburtstag: "Geburtsdatum",
                // strasse: "Straße",
                // hausnummer: "Hausnummer",
                // plz: "PLZ",
                // ort: "Ort",

                PaymentMode: {
                    label: "Zahlungsart",
                    type: "replace",
                    replace: {
                        OTHER: "individuelle Zahlungsweise",
                        DIRECTDEBIT: "SEPA-Lastschrift",
                        CREDITTRANSFER: "Überweisung",
                        PAYMENTFORM: "Zahlschein",
                        POSTALPAYMENT: "individuelle Zahlungsweise",
                    },
                },
                PaymentInterval: {
                    label: "Abbuchungszyklus",
                    type: "replace",
                    replace: {
                        MONTHLY: "monatlich",
                        YEARLY: "jährlich",
                        "HALF-YEARLY": "halbjährlich",
                        SINGULAR: "einmalig",
                        QUARTERLY: "vierteljährlich",
                        "BI-MONTHLY": "zweimonatlich",
                        IRREGULAR: "optional",
                        //monatlich/vierteljährlich/jährlich/einmalig
                    },
                },
                GrossAmount: {
                    label: "Abbuchungsbetrag",
                    type: "currency",
                },
                FromDate: {
                    label: "Erstmals ab",
                    type: "date",
                },
                // KfzBezeichnung: "KFZ-Bezeichnung",
                // KfzBaujahr: "KFZ-Baujahr",
                // KfzLeistung: "KFZ-Leistung",
                // KfzKennzeichen: "KFZ-Kennzeichen"
            },
            person: {
                mainHeadline: "Vertragsinhaber",
                secondHeadline: "Versicherte Person",
                thirdHeadline: "Versichertes Kind",
                // geschlecht: {
                //     type: "replace",
                //     label: "Geschlecht",
                //     replace: {
                //         Herr: "männlich",
                //         Frau: "weiblich"
                //     }
                // },
                // titel: "Titel",
                vorname: "Vorname",
                nachname: "Nachname",
                // telefon: "Telefon",
                // email: "E-Mail",
                geburtstag: "Geburtsdatum",
                // strasse: "Straße",
                // hausnummer: "Hausnummer",
                // plz: "PLZ",
                // ort: "Ort"
            },
            produkt: {
                GrossAmount: {
                    label: "aktuelle Prämie",
                    type: "currency",
                },
                // "Kraftfahrzeug-Haftpflichtversicherung":
                //     "Kraftfahrzeug-Haftpflichtversicherung",
                // "Kraftfahrzeug-Vollkaskoversicherung":
                //     "Kraftfahrzeug-Vollkaskoversicherung",
                // "Kraftfahrzeug-Teilkaskoversicherung":
                //     "Kraftfahrzeug-Teilkaskoversicherung",
                // Rechtsschutzversicherung: "Rechtsschutzversicherung",
                // "Lenker-Unfallversicherung": "Lenker-Unfallversicherung",

                "Kraftfahrzeug-Haftpflichtversicherung-Amount": {
                    label: "Kraftfahrzeug-Haftpflichtversicherung",
                    type: "currency",
                    checkStatus: true,
                },
                "Kraftfahrzeug-Vollkaskoversicherung-Amount": {
                    label: "Kraftfahrzeug-Vollkaskoversicherung",
                    type: "currency",
                    checkStatus: true,
                },
                "Kraftfahrzeug-Teilkaskoversicherung-Amount": {
                    label: "Kraftfahrzeug-Teilkaskoversicherung",
                    type: "currency",
                    checkStatus: true,
                },
                "Rechtsschutzversicherung-Amount": {
                    label: "Rechtsschutzversicherung",
                    type: "currency",
                    checkStatus: true,
                },
                "Lenker-Unfallversicherung-Amount": {
                    label: "Lenker-Unfallversicherung",
                    type: "currency",
                    checkStatus: true,
                },

                // "motorbezogene versicherungssteuer": "xxxxxx",

                "Motorbezogene Versicherungssteuer-Amount": {
                    label: "Motorbezogene Versicherungssteuer",
                    type: "currency",
                    checkStatus: true,
                },

                Hauptfälligkeit: {
                    label: "Hauptfälligkeit",
                    type: "replace",
                    replace: monthNames,
                },
                FromDate: {
                    label: "Vertragsbeginn",
                    type: "date",
                },
                Status: "Status des Produkts",
                // Zusatzleistungen: "xxxxxxx"
            },
        },
        EigenheimHaushalt: {
            allgemein: {
                Name: "Produktname",
                ContractIdFormatted: "Polizzennummer",
                Risikoadresse: "Versichertes Objekt",
                // FromDate: {
                //     label: "Vertragsbeginn",
                //     type: "date"
                // },
                // GrossAmount: {
                //     label: "aktuelle Prämie",
                //     type: "currency"
                // }
            },
            zahlung: {
                AccountHolderName: "Inhaber",
                BankName: "Bank",
                Iban: {
                    label: "IBAN",
                    type: "iban",
                },
                Bic: "BIC",
                DirectDebitDay: {
                    label: "Abbuchungszeitpunkt",
                    type: "replace",
                    replace: {
                        5: "Am 5. des Monats",
                        15: "Am 15. des Monats",
                        25: "Am 25. des Monats",
                    },
                },
                // geschlecht: {
                //     type: "replace",
                //     label: "Geschlecht",
                //     replace: {
                //         Herr: "männlich",
                //         Frau: "weiblich"
                //     }
                // },
                // titel: "Titel",
                vorname: "Vorname",
                nachname: "Nachname",
                // telefon: "Telefon",
                // email: "E-Mail",
                geburtstag: "Geburtsdatum",
                // strasse: "Straße",
                // hausnummer: "Hausnummer",
                // plz: "PLZ",
                // ort: "Ort",

                PaymentInterval: {
                    label: "Abbuchungszyklus",
                    type: "replace",
                    replace: {
                        MONTHLY: "monatlich",
                        YEARLY: "jährlich",
                        "HALF-YEARLY": "halbjährlich",
                        SINGULAR: "einmalig",
                        QUARTERLY: "vierteljährlich",
                        "BI-MONTHLY": "zweimonatlich",
                        IRREGULAR: "optional",
                        //monatlich/vierteljährlich/jährlich/einmalig
                    },
                },
                PaymentMode: {
                    label: "Zahlungsart",
                    type: "replace",
                    replace: {
                        OTHER: "individuelle Zahlungsweise",
                        DIRECTDEBIT: "SEPA-Lastschrift",
                        CREDITTRANSFER: "Überweisung",
                        PAYMENTFORM: "Zahlschein",
                        POSTALPAYMENT: "individuelle Zahlungsweise",
                    },
                },
                GrossAmount: {
                    label: "Abbuchungsbetrag",
                    type: "currency",
                },
                FromDate: {
                    label: "Erstmals ab",
                    type: "date",
                },
            },
            person: {
                mainHeadline: "Vertragsinhaber",
                secondHeadline: "Versicherte Person",
                thirdHeadline: "Versichertes Kind",
                // geschlecht: {
                //     type: "replace",
                //     label: "Geschlecht",
                //     replace: {
                //         Herr: "männlich",
                //         Frau: "weiblich"
                //     }
                // },
                // titel: "Titel",
                vorname: "Vorname",
                nachname: "Nachname",
                // telefon: "Telefon",
                // email: "E-Mail",
                geburtstag: "Geburtsdatum",
                // strasse: "Straße",
                // hausnummer: "Hausnummer",
                // plz: "PLZ",
                // ort: "Ort"
            },
            produkt: {
                // Höchsthaftungssumme: {
                //     label: "Höchsthaftungssumme",
                //     type: "currency"
                // },
                HöchsthaftungssummeHaushalt: {
                    label: "Höchsthaftungssumme Haushalt",
                    type: "currency",
                },
                HöchsthaftungssummeEigenheim: {
                    label: "Höchsthaftungssumme Eigenheim",
                    type: "currency",
                },
                Hauptfälligkeit: {
                    label: "Hauptfälligkeit",
                    type: "replace",
                    replace: monthNames,
                },
                GrossAmount: {
                    label: "aktuelle Prämie",
                    type: "currency",
                },
                FromDate: {
                    label: "Vertragsbeginn",
                    type: "date",
                },
            },
        },
        Rechtschutz: {
            allgemein: {
                Name: "Produktname",
                ContractIdFormatted: "Polizzennummer",
                // FromDate: {
                //     label: "Vertragsbeginn",
                //     type: "date"
                // },
                // GrossAmount: {
                //     label: "aktuelle Prämie",
                //     type: "currency"
                // }
            },
            zahlung: {
                AccountHolderName: "Inhaber",
                BankName: "Bank",
                Iban: {
                    label: "IBAN",
                    type: "iban",
                },
                Bic: "BIC",
                DirectDebitDay: {
                    label: "Abbuchungszeitpunkt",
                    type: "replace",
                    replace: {
                        5: "Am 5. des Monats",
                        15: "Am 15. des Monats",
                        25: "Am 25. des Monats",
                    },
                },
                // geschlecht: {
                //     type: "replace",
                //     label: "Geschlecht",
                //     replace: {
                //         Herr: "männlich",
                //         Frau: "weiblich"
                //     }
                // },
                // titel: "Titel",
                vorname: "Vorname",
                nachname: "Nachname",
                // telefon: "Telefon",
                // email: "E-Mail",
                geburtstag: "Geburtsdatum",
                // strasse: "Straße",
                // hausnummer: "Hausnummer",
                // plz: "PLZ",
                // ort: "Ort",

                PaymentMode: {
                    label: "Zahlungsart",
                    type: "replace",
                    replace: {
                        OTHER: "individuelle Zahlungsweise",
                        DIRECTDEBIT: "SEPA-Lastschrift",
                        CREDITTRANSFER: "Überweisung",
                        PAYMENTFORM: "Zahlschein",
                        POSTALPAYMENT: "individuelle Zahlungsweise",
                    },
                },
                PaymentInterval: {
                    label: "Abbuchungszyklus",
                    type: "replace",
                    replace: {
                        MONTHLY: "monatlich",
                        YEARLY: "jährlich",
                        "HALF-YEARLY": "halbjährlich",
                        SINGULAR: "einmalig",
                        QUARTERLY: "vierteljährlich",
                        "BI-MONTHLY": "zweimonatlich",
                        IRREGULAR: "optional",
                        //monatlich/vierteljährlich/jährlich/einmalig
                    },
                },
                GrossAmount: {
                    label: "Abbuchungsbetrag",
                    type: "currency",
                },
            },
            person: {
                mainHeadline: "Vertragsinhaber",
                secondHeadline: "Versicherte Person",
                thirdHeadline: "Versichertes Kind",
                // geschlecht: {
                //     type: "replace",
                //     label: "Geschlecht",
                //     replace: {
                //         Herr: "männlich",
                //         Frau: "weiblich"
                //     }
                // },
                // titel: "Titel",
                vorname: "Vorname",
                nachname: "Nachname",
                // telefon: "Telefon",
                // email: "E-Mail",
                geburtstag: "Geburtsdatum",
                // strasse: "Straße",
                // hausnummer: "Hausnummer",
                // plz: "PLZ",
                // ort: "Ort"
            },
            produkt: {
                GrossAmount: {
                    label: "aktuelle Prämie",
                    type: "currency",
                },
                Hauptfälligkeit: {
                    label: "Hauptfälligkeit",
                    type: "replace",
                    replace: monthNames,
                },
                FromDate: {
                    label: "Vertragsbeginn",
                    type: "date",
                },
            },
        },
        UnfallKrankheit: {
            allgemein: {
                Name: "Produktname",
                ContractIdFormatted: "Polizzennummer",
                // FromDate: {
                //     label: "Vertragsbeginn",
                //     type: "date"
                // },
                // GrossAmount: {
                //     label: "aktuelle Prämie",
                //     type: "currency"
                // }
            },
            zahlung: {
                AccountHolderName: "Inhaber",
                BankName: "Bank",
                Iban: {
                    label: "IBAN",
                    type: "iban",
                },
                Bic: "BIC",
                DirectDebitDay: {
                    label: "Abbuchungszeitpunkt",
                    type: "replace",
                    replace: {
                        5: "Am 5. des Monats",
                        15: "Am 15. des Monats",
                        25: "Am 25. des Monats",
                    },
                },
                // geschlecht: {
                //     type: "replace",
                //     label: "Geschlecht",
                //     replace: {
                //         Herr: "männlich",
                //         Frau: "weiblich"
                //     }
                // },
                // titel: "Titel",
                vorname: "Vorname",
                nachname: "Nachname",
                // telefon: "Telefon",
                // email: "E-Mail",
                geburtstag: "Geburtsdatum",
                // strasse: "Straße",
                // hausnummer: "Hausnummer",
                // plz: "PLZ",
                // ort: "Ort",

                PaymentMode: {
                    label: "Zahlungsart",
                    type: "replace",
                    replace: {
                        OTHER: "individuelle Zahlungsweise",
                        DIRECTDEBIT: "SEPA-Lastschrift",
                        CREDITTRANSFER: "Überweisung",
                        PAYMENTFORM: "Zahlschein",
                        POSTALPAYMENT: "individuelle Zahlungsweise",
                    },
                },
                PaymentInterval: {
                    label: "Abbuchungszyklus",
                    type: "replace",
                    replace: {
                        MONTHLY: "monatlich",
                        YEARLY: "jährlich",
                        "HALF-YEARLY": "halbjährlich",
                        SINGULAR: "einmalig",
                        QUARTERLY: "vierteljährlich",
                        "BI-MONTHLY": "zweimonatlich",
                        IRREGULAR: "optional",
                        //monatlich/vierteljährlich/jährlich/einmalig
                    },
                },
                GrossAmount: {
                    label: "Abbuchungsbetrag",
                    type: "currency",
                },
            },
            person: {
                mainHeadline: "Vertragsinhaber",
                secondHeadline: "Versicherte Person",
                thirdHeadline: "Versichertes Kind",
                // geschlecht: {
                //     type: "replace",
                //     label: "Geschlecht",
                //     replace: {
                //         Herr: "männlich",
                //         Frau: "weiblich"
                //     }
                // },
                // titel: "Titel",
                vorname: "Vorname",
                nachname: "Nachname",
                // telefon: "Telefon",
                // email: "E-Mail",
                geburtstag: "Geburtsdatum",
                // strasse: "Straße",
                // hausnummer: "Hausnummer",
                // plz: "PLZ",
                // ort: "Ort"
            },
            produkt: {
                GrossAmount: {
                    label: "aktuelle Prämie",
                    type: "currency",
                },
                FromDate: {
                    label: "Vertragsbeginn",
                    type: "date",
                },
                Wertanpassung: {
                    label: "Wertanpassung",
                    type: "replace",
                    replace: {
                        J: "ja",
                        N: "nein",
                    },
                },
            },
        },
        Finanzierung: {
            allgemein: {
                Name: "Produktname",
                ContractIdFormatted: "Vertragsnummer",
                Balance: {
                    label:
                        "Saldo per " +
                        DateFormatter.formatDate(saldoDate, "DD.MM.YYYY"),
                    type: "currency",
                },
                // FromDate: {
                //     label: "Vertragsbeginn",
                //     type: "date"
                // },
                // ContractAmount: {
                //     label: "Darlehenssumme",
                //     type: "currency"
                // },
                // GrossAmount: {
                //     label: "aktuelle Rate",
                //     type: "currency"
                // },
                // NetAmount: {
                //     label: "Getätigte Einzahlungen lfd. Jahr",
                //     type: "currency"
                // },
                // AmountPaid: {
                //     label: "Getätigte Einzahlungen",
                //     type: "currency"
                // }
            },
            zahlung: {
                AccountHolderName: "Inhaber",
                BankName: "Bank",
                Iban: {
                    label: "IBAN",
                    type: "iban",
                },
                Bic: "BIC",
                DirectDebitDay: {
                    label: "Abbuchungszeitpunkt",
                    type: "replace",
                    replace: {
                        5: "Am 5. des Monats",
                        15: "Am 15. des Monats",
                        25: "Am 25. des Monats",
                    },
                },
                // geschlecht: {
                //     type: "replace",
                //     label: "Geschlecht",
                //     replace: {
                //         Herr: "männlich",
                //         Frau: "weiblich"
                //     }
                // },
                // titel: "Titel",
                vorname: "Vorname",
                nachname: "Nachname",
                // telefon: "Telefon",
                // email: "E-Mail",
                geburtstag: "Geburtsdatum",
                // strasse: "Straße",
                // hausnummer: "Hausnummer",
                // plz: "PLZ",
                // ort: "Ort",

                PaymentMode: {
                    label: "Zahlungsart",
                    type: "replace",
                    replace: {
                        OTHER: "individuelle Zahlungsweise",
                        DIRECTDEBIT: "SEPA-Lastschrift",
                        CREDITTRANSFER: "Überweisung",
                        PAYMENTFORM: "Zahlschein",
                        POSTALPAYMENT: "individuelle Zahlungsweise",
                    },
                },
                PaymentInterval: {
                    label: "Abbuchungszyklus",
                    type: "replace",
                    replace: {
                        MONTHLY: "monatlich",
                        YEARLY: "jährlich",
                        "HALF-YEARLY": "halbjährlich",
                        SINGULAR: "einmalig",
                        QUARTERLY: "vierteljährlich",
                        "BI-MONTHLY": "zweimonatlich",
                        IRREGULAR: "optional",
                        //monatlich/vierteljährlich/jährlich/einmalig
                    },
                },
                GrossAmount: {
                    label: "Abbuchungsbetrag",
                    type: "currency",
                },
            },
            person: {
                mainHeadline: "Vertragsinhaber",
                secondHeadline: "Gesetzlicher Vertreter",
                // geschlecht: {
                //     type: "replace",
                //     label: "Geschlecht",
                //     replace: {
                //         Herr: "männlich",
                //         Frau: "weiblich"
                //     }
                // },
                // titel: "Titel",
                vorname: "Vorname",
                nachname: "Nachname",
                // telefon: "Telefon",
                // email: "E-Mail",
                geburtstag: "Geburtsdatum",
                // strasse: "Straße",
                // hausnummer: "Hausnummer",
                // plz: "PLZ",
                // ort: "Ort"
            },
            produkt: {
                ContractAmount: {
                    label: "Darlehenssumme",
                    type: "currency",
                },
                GrossAmount: {
                    label: "aktuelle Rate",
                    type: "currency",
                },
                // NetAmount: {
                //     label: "Getätigte Einzahlungen lfd. Jahr",
                //     type: "currency"
                // },
                // AmountPaid: {
                //     label: "Getätigte Einzahlungen der Vorjahre",
                //     type: "currency"
                // },
                FromDate: {
                    label: "Vertragsbeginn",
                    type: "date",
                },
            },
        },
    };
};

const state = getDefaultState();

export default {
    state,
};
